'use client'

import { useAtom } from 'jotai'
import { useTranslations } from 'next-intl'

import {
  SettingsCard,
  SettingsCardHeader,
  SettingsRow,
  SettingsRowGroup,
} from '@/components/dialog/settings/settings-card'
import { Switch } from '@/components/ui/switch'
import { FILTERABLE_NOTIFICATION_CATEGORIES, notificationFiltersAtom } from '@/state/notifications'
import { soundSettingsAtom } from '@/state/storage'

export function NotificationPreferencesCard() {
  const t = useTranslations('settings.notifications.preferences')
  const categoryT = useTranslations('notifications.filters')
  const [soundSettings, setSoundSettings] = useAtom(soundSettingsAtom)
  const [filters, setFilters] = useAtom(notificationFiltersAtom)

  return (
    <SettingsCard className="gap-4">
      <SettingsCardHeader title={t('title')} description={t('description')} />

      <SettingsRowGroup>
        <SettingsRow
          label={t('tradeSound')}
          description={t('tradeSoundDescription')}
          control={
            <Switch
              checked={soundSettings.tradeSound}
              onCheckedChange={(checked) =>
                setSoundSettings((previous) => ({ ...previous, tradeSound: checked }))
              }
              aria-label={t('tradeSound')}
            />
          }
        />
      </SettingsRowGroup>

      <div className="border-foreground/10 flex flex-col gap-2 border-t pt-4">
        <SettingsCardHeader title={t('categoriesTitle')} description={t('categoriesDescription')} />
        <SettingsRowGroup>
          {FILTERABLE_NOTIFICATION_CATEGORIES.map((category) => (
            <SettingsRow
              key={category}
              label={categoryT(category)}
              className="py-2"
              control={
                <Switch
                  checked={filters[category]}
                  onCheckedChange={(checked) =>
                    setFilters((previous) => ({ ...previous, [category]: checked }))
                  }
                  aria-label={categoryT(category)}
                />
              }
            />
          ))}
        </SettingsRowGroup>
      </div>
    </SettingsCard>
  )
}
